import { cn } from '../../lib/cn';
import { ORDINE_STATI, STATI, type ConteggioStati, type StatoPartecipante } from '../../lib/eventi/stati';

type Props = {
  conti: ConteggioStati;
  attivo: StatoPartecipante | 'tutti';
  onScegli: (stato: StatoPartecipante | 'tutti') => void;
};

/** Nella barra prima chi e' piu' avanti: confermati, bozze, richieste, chi non ha scelto. */
const ORDINE_BARRA = [...ORDINE_STATI].reverse();

/**
 * A che punto sono le richieste: quanti hanno scelto, una barra colorata con
 * tutti gli stati e, sotto, un bottone per stato che filtra l'elenco.
 */
export function ContatoriStati({ conti, attivo, onScegli }: Props) {
  const hannoScelto = conti.totale - conti.da_scegliere;
  const percentuale = conti.totale === 0 ? 0 : Math.round((hannoScelto / conti.totale) * 100);
  const voci: { id: StatoPartecipante | 'tutti'; etichetta: string; n: number; colore?: string }[] = [
    { id: 'tutti', etichetta: 'Tutti', n: conti.totale },
    ...ORDINE_STATI.map((s) => ({ id: s, etichetta: STATI[s].plurale, n: conti[s], colore: STATI[s].colore })),
  ];

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm md:p-5">
      <div className="flex flex-wrap items-end justify-between gap-2">
        <p className="text-sm text-neutral-600">
          <span className="mr-1 text-2xl font-bold tabular-nums text-gray-900">{hannoScelto}</span>
          su {conti.totale} hanno inviato la loro scelta
        </p>
        <span className="text-sm font-semibold tabular-nums text-neutral-700">{percentuale}%</span>
      </div>
      <div className="mt-3 flex h-2.5 overflow-hidden rounded-full bg-gray-100" aria-hidden>
        {ORDINE_BARRA.map((s) =>
          conti[s] > 0 ? <span key={s} className={STATI[s].colore} style={{ width: `${(conti[s] / conti.totale) * 100}%` }} /> : null,
        )}
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        {voci.map((v) => (
          <button
            key={v.id}
            type="button"
            aria-pressed={attivo === v.id}
            onClick={() => onScegli(attivo === v.id ? 'tutti' : v.id)}
            className={cn(
              'inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500',
              attivo === v.id ? 'border-gray-900 bg-gray-900 text-white' : 'border-gray-200 bg-white text-neutral-700 hover:border-gray-300',
            )}
          >
            {v.colore && <span className={cn('h-2 w-2 rounded-full', v.colore)} />}
            <span>{v.etichetta}</span>
            <span className="font-semibold tabular-nums">{v.n}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
